/* globals jQuery */
import 'fitvids.1.1.0'
import 'flexslider'
import 'magnific-popup'
import objectFitImages from 'object-fit-images';

import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    //polyfill for IE object-fit on images - https://github.com/fregante/object-fit-images
    var $objectFit = $('img.object-fit');
    objectFitImages($objectFit);

    //main hero slideshow
    $('.hero-slider.flexslider').flexslider({directionNav:false});

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'offCanvas', //default option for dropdown type use 'dropdown'
        closeOnOutsideClick: true, //set to false if using dropdown type
        showTabsOnFocus: true,
    });

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion();


    //Details Details Popup
    $('.js-brew-popup').magnificPopup({
        type:'inline',
        midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        removalDelay: 300,
        mainClass: 'mfp-fade',
        //closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
        callbacks: {
            elementParse: function(item) {

                var data = {
                    action : 'get_brew',
                    brewId : $(item.el).data('id'),
                    postType : $(item.el).data('posttype')
                };

                $.post(wp_ajax.url, data, function(response) {
                    $('#brew-popup').append(response.html);
                    $('#brew-popup .spinner').hide();
                });
            },
            close: function(){
                $('#brew-popup .spinner').show();
                $('#brew-popup .popup__content').remove();
            }
        }
    });

	$('.woocommerce-product-categories .widgettitle').on('click', function(){
		var catList = $(this).next('ul');

		catList.slideToggle();
	});

	//should probalby add in some sort of debounce/timeout but this covers it being hidden when resizing from mobile to larger
	$(window).resize( function() {
		if( $(window).width() > 767 ){
			$('.woocommerce-product-categories .widgettitle').next('ul').removeAttr('style');
		}
	})


	//OVER 21 POPUP
	if( document.cookie.indexOf('sevenseas_onload_age_check') < 0 ){
		//console.log( 'show popup: ' + document.cookie.indexOf('sevenseas_onload_age_check') );
		$.magnificPopup.open({
			items: { src: '#over21-popup' },
			type: 'inline',
			modal: true,
			mainClass: 'mfp-fade mfp-message',
			showCloseBtn: false
		});
	}

	$(document).on('click', '.js-message-dismiss', function (e) {
		e.preventDefault();
		$.magnificPopup.close();

		document.cookie = 'sevenseas_onload_age_check=1;path=/;';

    });

    $('#pickup_contact_name_field').hide();
    $('#pickup_contact_dob_field').hide();

    $('#customer_pickup').on('change', function(){
        if($('#customer_pickup').val()==='customer') {
            $('#pickup_contact_name_field').hide();
            //$('#pickup_contact_name').val('');
            $('#pickup_contact_dob_field').hide();
            //$('#pickup_contact_dob').val('');
        }else{
            $('#pickup_contact_name_field').show();
            $('#pickup_contact_dob_field').show();
        }
        
	});


})(jQuery)
